import { useEffect, useState } from 'react';
import { Button, Card, Form, Modal } from 'react-bootstrap';

const TypeProductAddModal = ({ show, handleClose, handleAddTypeProducts, parsingDataEdit }) => {
    
    const [typeProducts, setTypeProducts] = useState({
        name: ''
    });

    useEffect(() => {
        if (parsingDataEdit) {
            setTypeProducts({
                name: parsingDataEdit.name
            });
        } else {
            setTypeProducts({ name: '' });
        }
    }, [parsingDataEdit]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTypeProducts({
            ...typeProducts,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (parsingDataEdit != null) {
            handleAddTypeProducts({ ...parsingDataEdit, ...typeProducts });
        } else {
            handleAddTypeProducts(typeProducts);
        }
        setTypeProducts({ name: '' });
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Type Product</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={typeProducts.name}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit">
                        Submit
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default TypeProductAddModal;